import { NgModule } from '@angular/core';
import { MainDebitListRoutingModule } from './main-debit-list-routing.module';

import { MainDebitListComponent } from './main-debit-list.component';
import { MainListPopupComponent } from './components/main-list-popup/main-list-popup.component';
import { MatTableModule } from '@angular/material/table';
import { MaterialModule } from 'ClientApp/app/modules/material/material.module';
import { TableComponent } from './components/table/table.component';
import { FilterComponent } from './components/filter/filter.component';
import { DebitListService } from './services/main-debit-list.service';
import { CommonModule } from '@angular/common';
import { ViewStatusComponent } from './components/view-status/view-status.component';
import { MaxCurrencyPipe } from './pipes/max-currency.pipe';
import { ExcelService } from './services/excel.service';
import { MatSortModule } from '@angular/material/sort';
import { SharedModule } from 'ClientApp/app/shared/shared.module';
import { CardholdersCoreModule } from 'ClientApp/app/shared/cardholders-core/cardholders-core.module';
import { UnfreezeDirectDebitPopUpComponent } from './components/unfreeze-direct-debit-popup/unfreeze-direct-debit-popup.component';

@NgModule({
    declarations: [
        MainDebitListComponent,
        MainListPopupComponent,
        TableComponent,
        FilterComponent,
        ViewStatusComponent,
        MaxCurrencyPipe,
        UnfreezeDirectDebitPopUpComponent
    ],

    imports: [
        CommonModule,
        MainDebitListRoutingModule,
        MatTableModule,
        MaterialModule,
        MatSortModule,
        SharedModule,
        CardholdersCoreModule
    ],
    exports: [],
    providers: [DebitListService, ExcelService]
})
export class MainDebitListModule {}
